import { computed } from 'vue'

import IconBulk from '@/assets/svg/bulk_messaging_icon.svg?component'
import IconPhone from '@/assets/svg/phone_icon.svg?component'
import IconWhatsapp from '@/assets/svg/whatsapp_business_icon.svg?component'
import IconConfig from '@/assets/svg/config_icon.svg?component'

import { useI18n } from 'vue-i18n'

import { CHAT_FILTER_COLORS } from '@/components/whatsapp/services/constants'
import { useWhatsAppNotificationStore } from '@/stores/useWhatsAppNotificationStore'
import { useWorkspaceStore } from '@/stores/useWorkspaceStore'

import type { IRoute } from '../interfaces/route.interface'

export const useSidebarRoutes = () => {
  const { t } = useI18n()
  const notificationStore = useWhatsAppNotificationStore()
  const workspace = useWorkspaceStore()

  const routes = computed<IRoute[]>(() => [
    {
      path: '/',
      icon: IconPhone,
      title: t('general.calls'),
    },
    {
      path: '/whatsapp',
      icon: IconWhatsapp,
      title: t('general.whatsapp'),
      // Cuantos de mis chats tienen algo por leer, en el mismo naranja del filtro
      // "Por responder": es el color con el que el agente ya asocia "esto te
      // espera a ti" dentro de la lista.
      badgeValue: notificationStore.unreadCount,
      badgeColor: CHAT_FILTER_COLORS.PENDING_REPLY,
      disabled: workspace.hasLoadedCampaigns && !workspace.hasWhatsAppCampaign,
      disabledTooltip: t('sidebar.no_whatsapp_campaigns'),
    },
    {
      path: '/bulk-messaging',
      icon: IconBulk,
      title: t('general.bulk_messaging'),
    },
    // {
    //   path: '/settings',
    //   icon: IconConfig,
    //   title: t('general.settings'),
    // },
  ])

  return {
    routes,
  }
}
